import { useSelector, shallowEqual } from 'react-redux';
import { createSelector } from 'reselect';

export const makeSelectorHook = (selector) => () =>
	useSelector(selector, shallowEqual);

export const makeSelectorFactoryHook = (selectorFactory) => {
	return (args) => useSelector(selectorFactory(args), shallowEqual);
};

export const createSelectorHook = (...args) => {
	const selector = createSelector(...args);
	const hook = makeSelectorHook(selector);
	return [selector, hook];
};

export const createSelectorFactoryHook = (...args) => {
	const selector = createSelector(...args);
	const hook = makeSelectorFactoryHook(selector);
	return [selector, hook];
};

export const selectProp = (name, defaultValue) => (substate) =>
	substate[name] || defaultValue;
